import React, { createContext, useContext, useEffect, FC, ReactNode } from 'react';
import { DefaultTheme } from 'styled-components';
import { useBlockitTheme, Branding } from './useTheme';

interface BlockitThemeContextValue {
  theme: DefaultTheme;
  branding: Branding;
  isAlluvium: boolean;
}

const BlockitThemeContext = createContext<BlockitThemeContextValue | null>(null);

const BLOCKIT_FAVICON = '/favicon.ico';
const ALLUVIUM_FAVICON = '/images/alluvium-favicon.svg';

interface BlockitThemeProviderProps {
  children: ReactNode;
}

export const BlockitThemeProvider: FC<BlockitThemeProviderProps> = ({ children }) => {
  const value = useBlockitTheme();

  useEffect(() => {
    document.title = value.isAlluvium ? 'Alluvium Health' : 'Blockit';

    const link: HTMLLinkElement | null = document.getElementById('app-favicon') as HTMLLinkElement;
    if (link) {
      link.href = value.isAlluvium ? ALLUVIUM_FAVICON : BLOCKIT_FAVICON;
      link.type = value.isAlluvium ? 'image/svg+xml' : 'image/x-icon';
    }
  }, [value.isAlluvium]);

  return <BlockitThemeContext.Provider value={value}>{children}</BlockitThemeContext.Provider>;
};

export function useBlockitThemeContext(): BlockitThemeContextValue {
  const context = useContext(BlockitThemeContext);
  if (!context) {
    throw new Error('useBlockitThemeContext must be used within a BlockitThemeProvider');
  }
  return context;
}
